import { Component, OnInit } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
    selector: 'app-employee-advance',
    templateUrl: './employee-advance.component.html',
    styleUrls: ['./employee-advance.component.css']
})
export class EmployeeAdvanceComponent implements OnInit {
    Submitted: boolean = false;
    Installmentreadonly = false;
    Amountreadonly = false;
    StaffNameByBranch = [];
    DateValidation: any;
    constructor(private payrollService: HrService, private lookupservice: LookupService,
        public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    SearchStaffLoanModel = {
        StaffIdentity: '',
        FirstName: '',
    }
    LoanList = [];
    GetAllLoan() {
        this.spinnerService.show();
        this.payrollService.GetAllLoan(JSON.stringify(this.SearchStaffLoanModel)).subscribe((response: any) => {
            this.LoanList = response.LoanList;
            this.spinnerService.hide();

        });
    };
    SalaryComponentStaffModel = {
        LoanID:0,
        StaffID: 0,
        LoanDate: '',
        Remarks: '',
        DeductionAmount: 0,
        PaidLoanAmount: 0,
        AccountNumber: 0,
        PaymentMode: 0,
        LoanAmount: 0,
        AdvanceTypeID: 0,
        MonthlyEntitlement: 0,
        TotalInstallments: 0,
        TotalDetuctionAmount: 0,
        PaymentModeID:0,
        ChequeNo:'',
        ChequeDate:'',
        BankID:0,
        BankAccountID:0,

    }

    Validation() {
        return this.SalaryComponentStaffModel.AdvanceTypeID == 0||this.SalaryComponentStaffModel.StaffID == 0||this.SalaryComponentStaffModel.PaymentModeID == 0 || (this.SalaryComponentStaffModel.PaymentModeID == 3 && this.SalaryComponentStaffModel.BankAccountID == 0);
    }

    Reset() {
        this.SalaryComponentStaffModel.LoanID = 0;
        this.SalaryComponentStaffModel.StaffID = 0;
        this.SalaryComponentStaffModel.DeductionAmount = 0;
        this.SalaryComponentStaffModel.LoanAmount = 0;
        this.SalaryComponentStaffModel.AdvanceTypeID = 0;
        this.SalaryComponentStaffModel.TotalInstallments = 0;
        this.SalaryComponentStaffModel.LoanDate = '';
        this.SalaryComponentStaffModel.Remarks = '';
        this.SalaryComponentStaffModel.PaymentModeID = 0;
        this.SalaryComponentStaffModel.BankID = 0;
        this.SalaryComponentStaffModel.BankAccountID = 0;
        this.SalaryComponentStaffModel.ChequeNo = '';
        this.SalaryComponentStaffModel.ChequeDate = '';
        this.Submitted=false;
    }

    Clear() {
        this.SearchStaffLoanModel.FirstName='';
        this.SearchStaffLoanModel.StaffIdentity='';
        this.LoanList=[];
        this.Reset();
    }

  
    SaveLoan(valid) {
        this.Submitted = true;
        if (valid && !this.Validation()) {
            this.Submitted = false;
            this.spinnerService.show();
            this.SalaryComponentStaffModel.LoanDate = this.SalaryComponentStaffModel.LoanDate != null && this.SalaryComponentStaffModel.LoanDate != '' ? moment(this.SalaryComponentStaffModel.LoanDate).format('DD-MMM-YYYY') : '';
            this.SalaryComponentStaffModel.ChequeDate = this.SalaryComponentStaffModel.ChequeDate != null && this.SalaryComponentStaffModel.ChequeDate != '' ? moment(this.SalaryComponentStaffModel.ChequeDate).format('DD-MMM-YYYY') : '';
            
            this.payrollService.SaveLoan(JSON.stringify(this.SalaryComponentStaffModel)).subscribe((data: any) => {
                this.spinnerService.hide();
                this.globalHelper.CheckActionStatus(data);
                this.GetAllLoan();
                this.Reset();
            });
        }
    }

    GetDeductionAmount() {

        if (this.SalaryComponentStaffModel.AdvanceTypeID == 2 && this.SalaryComponentStaffModel.TotalInstallments != 0) {
            this.SalaryComponentStaffModel.DeductionAmount = 0;

            this.SalaryComponentStaffModel.DeductionAmount = (this.SalaryComponentStaffModel.LoanAmount / this.SalaryComponentStaffModel.TotalInstallments)
            //(Math.round((num * 1000) / 10) / 100).toFixed(2)
        }

        this.GetInstallment();
    }


    GetInstallment() {

        if (this.SalaryComponentStaffModel.DeductionAmount != null && this.SalaryComponentStaffModel.DeductionAmount != 0) {
            var remainder = this.SalaryComponentStaffModel.LoanAmount % this.SalaryComponentStaffModel.DeductionAmount;
           
            if (remainder > 0) {
                this.SalaryComponentStaffModel.TotalInstallments = Math.floor(this.SalaryComponentStaffModel.LoanAmount / this.SalaryComponentStaffModel.DeductionAmount) + 1;
            }
            else {
                this.SalaryComponentStaffModel.TotalInstallments = (this.SalaryComponentStaffModel.LoanAmount / this.SalaryComponentStaffModel.DeductionAmount);
            }
        }
    }

  
   
   
    LoanDetails = {
        StaffIdentity: '',
        LoanID: 0,
        FirstName: '',
        MiddleName:'',
        LastName:'',
        LoanDate: '',
        LoanAmount: 0,
        TotalInstallments: 0,
        PaidLoanAmount: 0,
        PaidInstallments: 0,
        DeductionAmount: 0,
        Remarks: '',
        BalanceAmount: 0,

    };

    

    CancelLoan(item) {
        var txt;
        var r = confirm("Are you sure? You want to cancel this advance.");
        if (r == true) {
           this.spinnerService.show();
           this.payrollService.CancelLoan(item.LoanID).subscribe((data: any) => {
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
            this.GetAllLoan();
            this.Reset();
        });
        }
    }

    LoanPaymentList=[];
   ViewLoan(item) {
        this.LoanDetails = item;
        this.spinnerService.show();
        this.payrollService.ViewLoan(item.LoanID).subscribe((data: any) => {
            this.LoanPaymentList = data.LoanPaymentList;
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
          
        });
    }

    ngOnInit() {
        this.GetStaffName();
        this.GetAdvanceType();
        this.GetPaymentMode();
        this. GetBank();
        this.GetBankAccount();
    }

    PaymentModeList = [];
    GetPaymentMode() {
        this.lookupservice.GetLookupsList('PaymentMode', '').subscribe((data: any) => {
            this.PaymentModeList = data.LookupItems;
        });
    };
    EmployeeList = [];
    GetStaffName() {
        this.SalaryComponentStaffModel.StaffID = 0;
        var itemBo = {
            'ItemId': 0
        };
        this.lookupservice.GetLookupsList('EmployeeCode', JSON.stringify(itemBo)).subscribe((data: any) => {
            this.EmployeeList = data.LookupItems;
        });
    };
    AdvaceTypeList=[];
    GetAdvanceType() {
        this.lookupservice.GetLookupsList('AdvanceType', '').subscribe((data: any) => {
            this.AdvaceTypeList = data.LookupItems;
            
        });
    };

    BankList = [];
    GetBank() {
        this.lookupservice.GetLookupsList('BankAll', '').subscribe((data: any) => {
            this.BankList = data.LookupItems;
        });
    };

    BankAccountList = [];
    GetBankAccount() {
        this.lookupservice.GetLookupsList('Bank', '').subscribe((data: any) => {
            this.BankAccountList = data.LookupItems;
        });
    };

    GetSaleStatementDownload(){

    }

}
